import LatexText from '../latex/LatexText';
import './OptionChip.css';

export type OptionChipColor = 'accent' | 'success' | 'error' | 'warning' | 'neutral';

export interface OptionChipProps {
    /** Option label (e.g. "A", "B"). Renders in a colored badge. */
    label: string;
    /** Option value/text — rendered with LaTeX support. Hidden if omitted. */
    value?: string;
    /** Badge color. Default "accent". */
    color?: OptionChipColor;
    /** Extra class for the outer wrapper. */
    className?: string;
}

/** Badge + inline value for an MCQ option: [A] : d²y/dx² */
export function OptionChip({ label, value, color = 'accent', className }: OptionChipProps) {
    const classes = ['option-chip', `option-chip--${color}`, className].filter(Boolean).join(' ');
    return (
        <span className={classes}>
            <span className="option-chip-label">{label}</span>
            {value && (
                <span className="option-chip-value"><LatexText text={value} /></span>
            )}
        </span>
    );
}
